/* ==========================================================
   DL v7 Sections — interactivity (v7)
   - Initial Picker: letter + metal + product CTA selection
     • LETTER-KEYED VARIANT IMAGE WINS over per-block override,
       so clicking a letter visibly updates the preview.
     • Per-block override is used only when no variant image
       exists for the current product × metal × letter.
     • Section-level default is the last fallback.
   - Stack Builder: unchanged
   ========================================================== */
(function() {
  'use strict';

  function formatMoney(cents, format) {
    format = format || '€{{amount_with_comma_separator}}';
    var value = cents / 100;
    function withCommas(num) {
      var parts = num.toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    function withSpaces(num) {
      var parts = num.toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return parts.join(',');
    }
    function withCommaSep(num) {
      var parts = num.toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return parts.join(',');
    }
    function withApostropheSep(num) {
      var parts = num.toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'");
      return parts.join('.');
    }
    function noDecimals(num) { return Math.round(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    function noDecimalsWithComma(num) { return Math.round(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
    function noDecimalsWithSpace(num) { return Math.round(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' '); }
    return format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimalsWithComma(value))
      .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, noDecimalsWithSpace(value))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals(value))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withCommaSep(value))
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, withSpaces(value))
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, withApostropheSep(value))
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas(value));
  }

  /* ===== INITIAL PICKER ===== */
  function initInitialPicker(root) {
    if (!root || root.dataset.dlv7Init === '1') return;
    root.dataset.dlv7Init = '1';

    var productMaps = {};
    try { productMaps = JSON.parse(root.dataset.productMaps || '{}'); } catch(e) {}

    var sectionDefaultImg = root.dataset.sectionDefaultImg || '';

    var chips = root.querySelectorAll('.dl-v7-initial__chip');
    var toggleBtns = root.querySelectorAll('.dl-v7-initial__toggle-btn');
    var previewImg = root.querySelector('.dl-v7-initial__preview img');
    var previewBox = root.querySelector('.dl-v7-initial__preview');
    var captionLetter = root.querySelector('.dl-v7-initial__caption-letter');
    var captionMetal = root.querySelector('.dl-v7-initial__caption-metal');
    var products = root.querySelectorAll('.dl-v7-initial__product');

    var state = {
      letter: root.dataset.defaultLetter || 'A',
      metal: root.dataset.defaultMetal || 'gold',
      productIdx: parseInt(root.dataset.defaultProductIdx || '0', 10)
    };

    function ensurePreviewImg() {
      if (previewImg || !previewBox) return;
      var img = document.createElement('img');
      img.alt = 'Initial preview';
      img.loading = 'lazy';
      img.width = 200; img.height = 200;
      previewBox.appendChild(img);
      previewImg = img;
    }

    function pickImage() {
      var pm = productMaps[state.productIdx] || productMaps[0] || {};
      var metalMap = pm[state.metal] || pm.gold || {};
      var entry = metalMap[state.letter];
      // 1) Letter-keyed variant image wins — so clicking a letter visibly
      //    changes the preview (even for CTAs that have an override image set).
      if (entry && entry.image) return entry.image;
      // 2) Per-block override (used when the product has no variant image for this letter).
      if (pm.__cta_override) return pm.__cta_override;
      // 3) Product featured fallback for active metal.
      if (metalMap.__fallback) return metalMap.__fallback;
      // 4) Section-level default override.
      return sectionDefaultImg || '';
    }

    function readMetalLabel(metalKey) {
      var btn = root.querySelector('.dl-v7-initial__toggle-btn[data-metal="' + metalKey + '"]');
      return btn ? btn.textContent.trim() : (metalKey.charAt(0).toUpperCase() + metalKey.slice(1));
    }

    function update() {
      if (captionLetter) captionLetter.textContent = state.letter;
      if (captionMetal) captionMetal.textContent = readMetalLabel(state.metal);

      ensurePreviewImg();
      var nextSrc = pickImage();
      if (previewImg && nextSrc) previewImg.src = nextSrc;

      products.forEach(function(p, idx) {
        var ppm = productMaps[idx] || {};
        var pMetalMap = ppm[state.metal] || ppm.gold || {};
        var letterEntry = pMetalMap[state.letter];
        var baseUrl = pMetalMap.__url || p.dataset.baseUrl || '#';
        if (letterEntry && letterEntry.variantId && baseUrl !== '#') {
          var sep = baseUrl.indexOf('?') >= 0 ? '&' : '?';
          p.setAttribute('href', baseUrl + sep + 'variant=' + letterEntry.variantId);
        } else {
          p.setAttribute('href', baseUrl);
        }
        if (idx === state.productIdx) p.classList.add('is-active');
        else p.classList.remove('is-active');
      });
    }

    chips.forEach(function(chip) {
      chip.addEventListener('click', function(e) {
        e.preventDefault();
        chips.forEach(function(c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        state.letter = chip.textContent.trim();
        update();
      });
    });

    toggleBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        toggleBtns.forEach(function(b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        state.metal = btn.dataset.metal || 'gold';
        update();
      });
    });

    products.forEach(function(p, idx) {
      p.addEventListener('click', function(e) {
        if (state.productIdx !== idx) {
          e.preventDefault();
          state.productIdx = idx;
          update();
        }
      });
    });

    update();
  }

  /* ===== STACK BUILDER (with custom dropdown) ===== */
  function initStackBuilder(root) {
    if (!root || root.dataset.dlv7Init === '1') return;
    root.dataset.dlv7Init = '1';

    var slots = root.querySelectorAll('.dl-v7-stack__slot');
    var priceEl = root.querySelector('.dl-v7-stack__price');
    var strikeEl = root.querySelector('.dl-v7-stack__strike');
    var ctaEl = root.querySelector('.dl-v7-stack__cta');
    var discountPct = parseFloat(root.dataset.discountPct || '15');
    var currencyFormat = root.dataset.currencyFormat || '€{{amount_with_comma_separator}}';
    var ctaBaseUrl = root.dataset.ctaBaseUrl || '/cart';

    var allDropdowns = [];

    function closeAllDropdowns(except) {
      allDropdowns.forEach(function(d) {
        if (d !== except) d.classList.remove('is-open');
      });
    }

    function recalc() {
      var fullCents = 0;
      var variantIds = [];

      slots.forEach(function(slot) {
        var ddl = slot.querySelector('.dl-v7-stack__ddl');
        if (!ddl) return;
        var selectedVariantId = ddl.dataset.selectedVariant || '';
        var selectedPriceCents = parseInt(ddl.dataset.selectedPriceCents || '0', 10);
        var selectedImage = ddl.dataset.selectedImage || '';
        fullCents += selectedPriceCents;
        if (selectedVariantId) variantIds.push(selectedVariantId);
        var imgEl = slot.querySelector('.dl-v7-stack__slot-img');
        if (imgEl && selectedImage) {
          imgEl.style.backgroundImage = 'url(' + selectedImage + ')';
        }
      });

      var bundleCents = Math.round(fullCents * (100 - discountPct) / 100);
      if (priceEl) priceEl.textContent = formatMoney(bundleCents, currencyFormat);
      if (strikeEl) strikeEl.textContent = formatMoney(fullCents, currencyFormat);

      if (ctaEl) {
        if (variantIds.length) {
          ctaEl.setAttribute('href', '/cart/' + variantIds.map(function(v) { return v + ':1'; }).join(','));
        } else {
          ctaEl.setAttribute('href', ctaBaseUrl);
        }
      }
    }

    slots.forEach(function(slot) {
      var ddl = slot.querySelector('.dl-v7-stack__ddl');
      if (!ddl) return;
      allDropdowns.push(ddl);

      var btn = ddl.querySelector('.dl-v7-stack__ddl-btn');
      var panel = ddl.querySelector('.dl-v7-stack__ddl-panel');
      var options = ddl.querySelectorAll('.dl-v7-stack__ddl-option');
      var btnThumb = ddl.querySelector('.dl-v7-stack__ddl-thumb');
      var btnLabel = ddl.querySelector('.dl-v7-stack__ddl-label');

      if (btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var willOpen = !ddl.classList.contains('is-open');
          closeAllDropdowns(ddl);
          if (willOpen) ddl.classList.add('is-open');
          else ddl.classList.remove('is-open');
        });
      }

      if (panel) {
        panel.addEventListener('click', function(e) { e.stopPropagation(); });
      }

      options.forEach(function(opt) {
        opt.addEventListener('click', function(e) {
          e.preventDefault();
          options.forEach(function(o) { o.classList.remove('is-selected'); });
          opt.classList.add('is-selected');

          ddl.dataset.selectedVariant = opt.dataset.variantId || '';
          ddl.dataset.selectedPriceCents = opt.dataset.priceCents || '0';
          ddl.dataset.selectedImage = opt.dataset.image || '';

          if (btnThumb && opt.dataset.image) {
            btnThumb.style.backgroundImage = 'url(' + opt.dataset.image + ')';
          }
          if (btnLabel) {
            btnLabel.textContent = opt.dataset.name || opt.textContent.trim();
          }

          ddl.classList.remove('is-open');
          recalc();
        });
      });
    });

    document.addEventListener('click', function() {
      closeAllDropdowns(null);
    });

    recalc();
  }

  function initAll() {
    document.querySelectorAll('.dl-v7-initial').forEach(initInitialPicker);
    document.querySelectorAll('.dl-v7-stack').forEach(initStackBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:select', initAll);
})();
